// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"309":"bf03ea35","475":"aab71a02","488":"12802ace","525":"41bfd2d4","874":"a646e885","946":"99cd5e00"}[chunkId] + ".chunk.js";
};